import React, { useState, useEffect } from 'react';
import styles from './Videos.module.css';

// Reemplazar videoId con los IDs reales de YouTube de @seimagt
const videosData = [
  { id: '1', title: 'Powr Flite Floor Machines Expert Recommendations', videoId: '-_IN4xbyKwc' },
  { id: '2', title: 'Powr Flite Comfort Pro Back Pack Vacuuming Made Easier', videoId: 'U1YS2xe0vOk' },
  { id: '3', title: 'Goodway® IRAM EX 100 Portable Chiller Tube Cleaner', videoId: '-IsdZdhkt10' },
  { id: '4', title: 'Goodway® Cleaning a Bread Slicer with the GVC 18000', videoId: 'X5Dy4FLGRCo' },
  { id: '5', title: 'DELFIN ATEX VACUUM SOLUTIONS FULL VIDEO 1', videoId: '9uRZyinXFSI' },
  { id: '6', title: 'Seima S.A. | Seima Suministros y mantenimientos', videoId: 'noomZao0mFI' }
];

const SeccionVideos = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(2);
  const [videoActivo, setVideoActivo] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setItemsPerPage(window.innerWidth <= 768 ? 1 : 2);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const totalPages = Math.ceil(videosData.length / itemsPerPage);

  const siguiente = () => {
    if (currentIndex < totalPages - 1) {
      setCurrentIndex(prev => prev + 1);
    }
  };

  const anterior = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
    }
  };

  return (
    <section className={styles.seccion}>
      <div className="container">
        
        <div className={styles.tituloContenedor}>
          <h2 className={styles.titulo}>
            Contenido <span className={styles.acento}>Adicional</span>
          </h2>
          <div className={styles.lineaTitulo} />
        </div>

        <div className={styles.galeriaContenedor}>
          <button 
            className={`${styles.btnFlecha} ${styles.izq}`} 
            onClick={anterior} 
            disabled={currentIndex === 0}
            aria-label="Anterior"
          >
            ‹
          </button>

          <div className={styles.videosWrapper}>
            <div 
              className={styles.videosTrack}
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {/* Group videos into pages (slides) */}
              {Array.from({ length: totalPages }).map((_, pageIndex) => (
                <div 
                  key={pageIndex} 
                  className={styles.videosTrack} 
                  style={{ flex: '0 0 100%', minWidth: '100%' }}
                >
                  {videosData
                    .slice(pageIndex * itemsPerPage, (pageIndex + 1) * itemsPerPage)
                    .map((video) => (
                      <div key={video.id} className={styles.videoSlide}>
                        <div className={styles.videoCard}>
                          <div className={styles.iframeWrapper}>
                            {videoActivo ? (
                              <div style={{ width: '100%', height: '100%', backgroundColor: '#000' }} />
                            ) : (
                              <iframe 
                                src={`https://www.youtube.com/embed/${video.videoId}?rel=0`} 
                                title={video.title}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen
                              ></iframe>
                            )}
                          </div>
                          <div 
                            className={styles.videoInfo} 
                            onClick={() => setVideoActivo(video)}
                            title="Haga clic para expandir video"
                          >
                            <h3 className={styles.videoTitle}>{video.title}</h3>
                          </div>
                        </div>
                      </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <button 
            className={`${styles.btnFlecha} ${styles.der}`} 
            onClick={siguiente} 
            disabled={currentIndex >= totalPages - 1}
            aria-label="Siguiente"
          >
            ›
          </button>
        </div>

        {/* Modal de Video Ampliado */}
        {videoActivo && (
          <div className={styles.lightbox} onClick={() => setVideoActivo(null)}>
            <div className={styles.lightboxContent} onClick={e => e.stopPropagation()}>
              <button 
                className={styles.closeBtn} 
                onClick={() => setVideoActivo(null)}
                aria-label="Cerrar video"
              >
                &times;
              </button>
              <div className={styles.iframeModalWrapper}>
                <iframe 
                  src={`https://www.youtube.com/embed/${videoActivo.videoId}?autoplay=1&rel=0`} 
                  title={videoActivo.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        )}

      </div>
    </section>
  );
};

export default SeccionVideos;
